import { getWorkspaceSchema } from "./get-workspace.schema";

export const patchWorkspaceSchema = getWorkspaceSchema;
